export const Diamond = ({ size = "12" }: { size?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_224_6291)">
      <path
        d="M7.86309 5.02148L6.00009 12.5215L4.13709 5.02148H7.86309ZM5.48659 0.521484L4.21409 4.02148H7.78609L6.51359 0.521484H5.48659ZM8.85009 4.02148H11.9206C11.8745 3.87883 11.807 3.74397 11.7206 3.62148L9.95509 1.14998C9.81636 0.955644 9.63324 0.79723 9.42096 0.687915C9.20868 0.578599 8.97336 0.521541 8.73459 0.521484H7.57759L8.85009 4.02148ZM8.89259 5.02148L7.51009 10.6715L11.6796 5.42148C11.7733 5.30036 11.8477 5.16542 11.9001 5.02148H8.89259ZM3.10759 5.02148H0.10009C0.153314 5.16543 0.228357 5.30034 0.32259 5.42148L4.49009 10.6715L3.10759 5.02148ZM3.15009 4.02148L4.42259 0.521484H3.26559C3.02681 0.521541 2.7915 0.578599 2.57922 0.687915C2.36694 0.79723 2.18382 0.955644 2.04509 1.14998L0.27959 3.62148C0.192953 3.74386 0.125509 3.87875 0.0795898 4.02148H3.15009Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_224_6291">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(0 0.521484)"
        />
      </clipPath>
    </defs>
  </svg>
);
